var _ = require('underscore');
module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="switch">\n  <div class="slider js-toggle"></div>\n</div>\n';
}
return __p;
};
